import React from "react";
import PropTypes from "prop-types";
import { MetricItem } from "./AccountDetails.styles";
import { LineChart } from "components/Chart";
import { Placeholder } from "components/Placeholder";

const ReturnValue = ({
  title = "Today's return",
  value = "$0.00",
  changePercentage = "0.00",
  changeText = "yesterday",
  chartData = [],
  chartColor,
  direction,
  isLoading = false,
}) => {
  const numericChange = parseFloat(changePercentage);
  const actualIsPositive = !Number.isNaN(numericChange) && numericChange >= 0;

  let changeColor;
  if (direction === "up") {
    changeColor = "#17B26A"; // Green for up
  } else if (direction === "down") {
    changeColor = "#DC6803"; // Red for down
  } else {
    changeColor = actualIsPositive ? "#17B26A" : "#DC6803"; // Default behavior
  }

  const finalChartColor = chartColor || changeColor;

  const transformedChartData = chartData.map((item) => ({
    value: item.$,
    name: item.name,
  }));

  const lines = [
    {
      key: "value",
      color: finalChartColor,
      name: title,
    },
  ];
  return (
    <MetricItem>
      <h3 className="metric-heading">{title}</h3>
      <Placeholder isLoading={isLoading}>
        <div className="metric-content">
          <div className="metric-left">
            <h2 className="metric-value">
              {value && value.includes(".") ? (
                <>
                  {value.split(".")[0]}
                  <span className="metric-value-decimal">
                    .{value.split(".")[1]}
                  </span>
                </>
              ) : (
                value
              )}
            </h2>
            <div className="metric-change">
              <div className="change-badge">
                <span
                  className="change-percentage"
                  style={{ color: changeColor }}
                >
                  {direction === "down"
                    ? "↓"
                    : direction === "up"
                    ? "↑"
                    : actualIsPositive
                    ? "↑"
                    : "↓"}{" "}
                  {Math.abs(parseFloat(changePercentage)) || "0"}%
                </span>
              </div>
              <span className="change-text">{changeText}</span>
            </div>
          </div>
          <div className="metric-chart">
            <LineChart
              data={transformedChartData}
              lines={lines}
              showAreaFill={true}
              margin={{ top: 5, right: 5, left: 5, bottom: 5 }}
            />
          </div>
        </div>
      </Placeholder>
    </MetricItem>
  );
};

ReturnValue.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  changePercentage: PropTypes.string,
  changeText: PropTypes.string,
  isPositive: PropTypes.bool,
  chartData: PropTypes.array,
  chartColor: PropTypes.string,
  direction: PropTypes.string,
  isLoading: PropTypes.bool,
};

export default ReturnValue;
